import CustomNetworkImage from "./CustomNetworkImage";
import SingleImagePopup from "../popup/SingleImagePopup";
import { useState } from "react";

function ClickableNetworkImage({ src, altText, size, width, height, borderRadius, isDisabled }) {
    const [isPopupOpen, setIsPopupOpen] = useState(false);

    const handleClose = () => {
        setIsPopupOpen(false);
    };

    return (
        <>
            <CustomNetworkImage
                src={src}
                altText={altText}
                size={size}
                width={width}
                height={height}
                borderRadius={borderRadius}
                isDisabled={isDisabled}
                onClick={() => setIsPopupOpen(true)}
                cursor={"pointer"}
            />
            <SingleImagePopup src={src} altText={altText} isOpen={isPopupOpen} onClose={handleClose} />
        </>
    );
}

export default ClickableNetworkImage;
